<script>
import { saveGet } from '../mixins/saveGet'

export default {
  name: 'MapModal',
  mixins: [saveGet],
  props: {
    company: {
      type: String,
      default: '-'
    },
    value: {
      type: Object,
      default: () => ({
        postalName: {
          language: 'de',
          value: 'GS1 Germany GmbH'
        },
        countryCode: 'DE',
        addressLocality: {
          language: 'de',
          value: 'Köln'
        },
        streetAddress: {
          language: 'de',
          value: 'Maarweg 133'
        },
        postalCode: '50825'
      })
    }
  },
  data: () => ({
    id: 'map-modal-' + Math.random().toString(10).substring(2)
  }),
  computed: {
    query() {
      const parts = []

      if (!this.value) {
        return ''
      }

      if (this.value.streetAddress) {
        parts.push(encodeURI(this.value.streetAddress.value))
      }

      if (this.value.postalCode) {
        parts.push(encodeURI(this.value.postalCode))
      }

      if (this.value.addressLocality) {
        parts.push(encodeURI(this.value.addressLocality.value))
      }

      return parts.join('+')
    },
    postalName() {
      return this.saveGet(this.value, this.company, 'postalName', 'value')
    }
  }
}

</script>

<template>
  <div>
    <div
      data-toggle='modal'
      :data-target="'#' + id"
      style='cursor: pointer'
    >
      <slot>
        <span class='fa fa-map' />
      </slot>
    </div>
    <div class='modal fade' :id='id' tabindex='-1'>
      <div class='modal-dialog modal-lg'>
        <div class='modal-content'>

          <div class='modal-header' style='border-top: none'>
            <button type='button' class='close' data-dismiss='modal'>
              <span>×</span>
            </button>
            <h4 class='modal-title' style='margin: 0; color: rgb(51, 51, 51)'>{{ postalName }}</h4>
          </div>
          <div class='modal-body' style='min-height: 480px'>
            <div class="loader" />
            <iframe
              style='border:0;position: relative; z-index: 0'
              width='100%'
              height='450'
              loading='lazy'
              allowfullscreen
              referrerpolicy='no-referrer-when-downgrade'
              :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyBRoUxfOjjt6uSPV8FZKKEQV_vdi-wuAyc&q=' + query" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.loader {

  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  border: 5px solid #f3f3f3;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  border-top: 5px solid var(--gs1-orange);
  border-radius: 50%;
  width: 50px;
  height: 50px;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/MapModal.vue